(self.webpackChunkyourkaya = self.webpackChunkyourkaya || []).push([
    [1541],
    {
        9913: () => {
            const s = "shopify-section-our-strengths",
                e = ".our-strengths",
                t = "hidden",
                n = document.getElementById(s),
                i = document.querySelector(e),
                a = window.location.pathname;
            function o() {
                n.classList.add(t);
            }
            a.indexOf("login") > -1 && !i.classList.contains("login-show") && o(),
                a.indexOf("register") > -1 && !i.classList.contains("register-show") && o(),
                a.indexOf("reset") > -1 && !i.classList.contains("reset-show") && o(),
                a.indexOf("activate") > -1 && !i.classList.contains("activate-show") && o();
        },
    },
    (s) => {
        var e;
        (e = 9913), s((s.s = e));
    },
]);
